let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("76j7Q")]).then(() => parcelRequire('7D8HD'));